<template>
    <div>
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.privacy-section-5 class="text-left fw-500">5. Fees and Charges</b-button>
            </b-card-header>
            <b-collapse id="privacy-section-5" visible accordion="my-accordion" role="tabpanel">
                <b-card-body>
                    <ol>
                        <li>Fee Schedule: RCPAY Virtual Account will charge fees for certain transactions as outlined in the fee schedule available on the Platform's website.</li>
                        <li>Changes to Fees: Fees are subject to change, and RCPAY Virtual Account will notify Account Holders of any changes at least 30 days in advance.</li>
                        <li>Payment of Fees: Fees will be automatically deducted from the VA. The Account Holder must ensure sufficient funds are available to cover the fees.</li>
                    </ol>
                </b-card-body>
            </b-collapse>
        </b-card>
      
    </div>
</template>

<script>
  
export default {
    name: 'section-5',
    data() {
        return {
        publicPath      : process.env.BASE_URL!='/'?process.env.BASE_URL:''
        };
    }
};
</script>